var _a, _b, _c, _d, _e, _f, _g, _h, _j;
import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { AnimTimeConstant, EasyEaseAnimation, mediaQuery } from './Constants';
export var useFirstRunPromotionStyles = makeStyles({
    container: {
        width: '100%',
        height: '100%',
        opacity: 0,
        display: 'block',
        pointerEvents: 'none',
        transitionDuration: AnimTimeConstant,
        transitionProperty: 'all',
        msTransitionTimingFunction: EasyEaseAnimation,
    },
    containerActive: {
        opacity: 1,
        pointerEvents: 'auto',
    },
    wrapper: __assign(__assign({}, shorthands.margin('0', '24px')), (_a = { height: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column' }, _a[mediaQuery.minMedium] = __assign({}, shorthands.margin('0', '32px')), _a[mediaQuery.minLarge] = __assign({}, shorthands.margin('0', '40px')), _a[mediaQuery.minExtraLarge] = __assign({ flexDirection: 'row' }, shorthands.margin('0', '48px')), _a)),
    contentLeft: __assign(__assign({}, shorthands.margin('0', 'auto')), (_b = {}, _b[mediaQuery.minExtraLarge] = {
        paddingRight: '40px',
    }, _b)),
    image: (_c = {
            width: '100%',
            height: '142px',
            backgroundPositionX: 'center',
            backgroundPositionY: 'center',
            backgroundRepeat: 'no-repeat',
            marginTop: '4px',
            marginBottom: '24px',
            backgroundSize: 'contain',
            '@media only screen and (min-width: 640px) and (max-width: 1023px)': {
                marginTop: '12px',
            }
        },
        _c[mediaQuery.minExtraLarge] = __assign({ width: 'auto', height: 'auto' }, shorthands.margin('0')),
        _c),
    contentRight: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    textWrapper: (_d = {
            width: '100%'
        },
        _d[mediaQuery.minExtraLarge] = {
            maxWidth: '394px',
            paddingTop: '54px',
        },
        _d),
    headlineText: {
        '> h2': __assign(__assign(__assign(__assign({}, shorthands.overflow('hidden')), { textOverflow: 'ellipsis', fontFamily: tokens.fontFamilyBase, fontWeight: 600, fontSize: '14px', lineHeight: '20px', paddingBottom: '12px' }), shorthands.margin(0)), (_e = {}, _e[mediaQuery.minLarge] = {
            fontSize: '16px',
            lineHeight: '22px',
        }, _e)),
    },
    titleText: {
        '> h3': __assign(__assign(__assign(__assign({}, shorthands.overflow('hidden')), { textOverflow: 'ellipsis', fontFamily: tokens.fontFamilyBase, fontWeight: '600', fontSize: '20px', lineHeight: '26px', paddingBottom: '20px' }), shorthands.margin(0)), (_f = {}, _f[mediaQuery.minLarge] = {
            fontSize: '24px',
            lineHeight: '32px',
        }, _f)),
    },
    highlightText: __assign(__assign(__assign({ fontWeight: '400', fontSize: '14px', lineHeight: '20px' }, shorthands.margin('0', '0', '12px', '0')), shorthands.padding('0')), (_g = { listStyleType: 'none', '> li': {
                marginBottom: '4px',
                height: '100%',
                width: '100%',
                position: 'relative',
                '> svg': (_h = {
                        position: 'absolute',
                        top: '1px',
                        fontSize: '16px'
                    },
                    _h[mediaQuery.minLarge] = {
                        fontSize: '20px',
                    },
                    _h),
            }, '& span': {
                marginLeft: '24px',
                display: 'block',
            } }, _g[mediaQuery.minMedium] = {
        marginBottom: '24px',
    }, _g[mediaQuery.minLarge] = {
        '& span': {
            marginLeft: '28px',
        },
    }, _g)),
    buttonContainer: (_j = {
            whiteSpace: 'nowrap',
            alignSelf: 'center'
        },
        _j[mediaQuery.minExtraLarge] = {
            alignSelf: 'flex-end',
        },
        _j),
});
//# sourceMappingURL=FirstRunPromotion.styles.js.map